import { Box, Image, Text, Link } from '@chakra-ui/react';
import logo from './resources/pm-logo-white.svg';
import instagramLogo from './resources/instagram-logo.svg';
import twitterLogo from './resources/twitter-logo.svg';
import facebookLogo from './resources/facebook-logo.svg';
import linkedinLogo from './resources/linkedin-logo.svg';
import youtubeLogo from './resources/youtube-logo.svg';
import pinterestLogo from './resources/pinterest-logo.svg';

function Footer() {
    return (
        <Box bg="midnight.700" padding="20px" textAlign="center">
            <Image
                height="60px"
                src={logo}
                alt="Logo"
                marginLeft="auto"
                marginRight="auto"
                padding="10px"
            />
            <Box textAlign="center">
                <Link
                    href="https://www.pathmatch.com/students"
                    color="hsla(0, 0%, 100%, 0.75)"
                    fontSize="14px"
                    fontWeight="600"
                    display="inline-block"
                    padding="20px"
                >
                    Students
                </Link>
                <Link
                    href="https://www.pathmatch.com/contact"
                    color="hsla(0, 0%, 100%, 0.75)"
                    fontSize="14px"
                    fontWeight="600"
                    display="inline-block"
                    padding="20px"
                >
                    Contact Us
                </Link>
                <Link
                    href="https://www.pathmatch.com/about-us"
                    color="hsla(0, 0%, 100%, 0.75)"
                    fontSize="14px"
                    fontWeight="600"
                    display="inline-block"
                    padding="20px"
                >
                    About Us
                </Link>
            </Box>
            <Box textAlign="center" display="inline-block" marginTop="20px">
                <Logo
                    link="https://instagram.com/thepathmatch"
                    logo={instagramLogo}
                    logoText="Instagram Link"
                />
                <Logo
                    link="https://twitter.com/thePathMatch"
                    logo={twitterLogo}
                    logoText="Twitter Link"
                />
                <Logo
                    link="https://www.facebook.com/thepathmatch"
                    logo={facebookLogo}
                    logoText="Facebook Link"
                />
                <Logo
                    link="https://www.linkedin.com/company/pathmatch/"
                    logo={linkedinLogo}
                    logoText="Linkedin Link"
                />
                <Logo
                    link="https://www.youtube.com/channel/UCFs-qerXMnbsZJOMOO1Cj1Q"
                    logo={youtubeLogo}
                    logoText="Youtube Link"
                />
                <Logo
                    link="https://www.pinterest.com/thepathmatch/_saved/"
                    logo={pinterestLogo}
                    logoText="Pinterest Link"
                />
            </Box>
            <Text
                textAlign="center"
                color="hsla(0, 0%, 100%, 0.5)"
                fontSize="12px"
                marginTop="30px"
            >
                Copyright @ 2020 PathMatch.com. All Rights Reserved.
            </Text>
            <Box textAlign="center">
                <Link
                    href="https://www.pathmatch.com/privacy"
                    color="hsla(0, 0%, 100%, 0.5)"
                    fontSize="12px"
                    fontWeight="600"
                    display="inline-block"
                    padding="10px"
                >
                    Privacy Policy
                </Link>
                <Link
                    href="https://www.pathmatch.com/terms"
                    color="hsla(0, 0%, 100%, 0.5)"
                    fontSize="12px"
                    fontWeight="600"
                    display="inline-block"
                    padding="10px"
                >
                    Terms & Conditions
                </Link>
            </Box>
        </Box>
    );
}

export default Footer;

function Logo({ link, logo, logoText }: { link: string; logo: string; logoText: string }) {
    return (
        <Link padding="20px" href={link}>
            <Image h={5} src={logo} alt={logoText} opacity=".5" display="inline-block" />
        </Link>
    );
}
